export default "__VITE_ASSET__CsX89xgo__"